import { TimelineFilterValues } from '../../StayTimeline.types'
import { AutoSendsFilter } from '../AutoSendsFilter'
import { ChannelsFilter } from '../ChannelsFilter'
import { NotesFilter } from '../NotesFilter'
import * as S from './StayTimelineFilters.styles'

interface StayTimelineFiltersProps {
  filters: TimelineFilterValues
  onFiltersChange: (changes: Partial<TimelineFilterValues>) => void
}

export const StayTimelineFilters = ({ filters, onFiltersChange }: StayTimelineFiltersProps) => {
  return (
    <S.Root>
      <ChannelsFilter
        value={filters.channels}
        onChange={channels => onFiltersChange({ channels })}
      />
      <AutoSendsFilter value={filters.sends} onChange={sends => onFiltersChange({ sends })} />
      <NotesFilter value={filters.notes} onChange={notes => onFiltersChange({ notes })} />
    </S.Root>
  )
}
